// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@tps/App/Components/Notify";
import { changeCustomerSelectCustomerContainerStyles } from "@tps/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { mergeWithCss, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionHidden = {
    css: css`
        display: none;
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    css: css`
        font-size: 12px;
        margin-top: 20px;
    `,
};

changeCustomerSelectCustomerContainerStyles.container = {
    gap: 20,
};

changeCustomerSelectCustomerContainerStyles.fulfillmentMethodSelectorGridItem = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.buttonsGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-direction: column-reverse;
            row-gap: 20px;
            button {
                width: 100%;
                margin: 0;
            }
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin-top: 20px;
            margin-bottom: 0;
        `,
    }),
};
